import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ObjectToolbar } from 'src/blocks/object-toolbar';
import ControlledTabs from 'src/components/controlled-tabs';
import { PageLayout } from 'src/layouts';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import useTabs from '@/hooks/useTabs';
import { addEnterpriseRiskUrl } from '@/utils/urls';

const Page: FC = () => {
  const { t } = useTranslation(['common']);
  const objectToolbarEnabled = useIsFeatureFlagEnabled('object_toolbar');
  const title = t('enterpriseRisks.createTitle');
  const tabs = useTabs({
    parentType: Parent_Type_Enum.EnterpriseRisk,
    parent: undefined,
    hrefRoot: addEnterpriseRiskUrl(),
    disabled: true,
  });

  return (
    <PageLayout
      title={title}
      // Object-level toolbar (CUS-167) — title-only on the create page; the
      // create form keeps its own Create/Cancel controls. Flag-gated fallback
      // to the legacy header.
      headerOverride={
        objectToolbarEnabled ? (
          <ObjectToolbar config={{ header: { title } }} />
        ) : undefined
      }
    >
      <ControlledTabs
        tabs={tabs}
        variant={'container'}
        parentType={Parent_Type_Enum.EnterpriseRisk}
        disableSettings
      />
    </PageLayout>
  );
};

export default Page;
